export function ManageStatisticsCtrl (
  $scope,
  $translate,
  dvlaLookupApi,
  messages,
  workshopAPI
) {
  $scope.periodValues = [
    { code: '*', description: 'All Time' },
    { code: '7DAYS', description: '7 Days' },
    { code: '30DAYS', description: '30 Days' }
  ];

  $scope.singleUsePurchases = {};

  $scope.stats_period = {
    period: '*'
  };

  $scope.DVLALookup = dvlaLookupApi;

  $scope.getAccountingName = function () {
    if ($scope.accounting === 'qbo') {
      return $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS');
    }

    return $scope.accounting;
  };

  $scope.getStats = function () {
    workshopAPI.get('/workshop_admin/company_statistics', $scope.company.id)
    .then(stats => {
      $scope.stats = stats;

      $scope.singleUsePurchases = {
        company: {
          checka_requests           : stats.checka_lookups,
          dvla_lookup_requests      : stats.dvla_lookups,
          id                        : $scope.company.id,
          sms_count_left            : stats.sms_available,
          uk_postcode_requests      : stats.uk_postcode_requests,
          video_storage_minutes     : stats.video_storage_minutes,
          haynes_pro_lookup_requests: stats.haynes_pro_lookups
        },
        company_integration: {
          registration_lookup_count: stats.registration_lookup_count
        }
      };

      const integrationCheck = {
        myob: stats.myob_active,
        xero: stats.xero_active,
        qbo : stats.qbo_active,
      };

      if (integrationCheck.myob && !integrationCheck.xero && !integrationCheck.qbo) {
        $scope.accounting = 'MYOB';
      }
      else if (!integrationCheck.myob && integrationCheck.xero && !integrationCheck.qbo) {
        $scope.accounting = 'Xero';
      }
      else if (!integrationCheck.myob && !integrationCheck.xero && integrationCheck.qbo) {
        $scope.accounting = 'qbo';

      }
      else if (!integrationCheck.myob && !integrationCheck.xero && !integrationCheck.qbo) {
        $scope.accounting = 'None';
      }
      else {
        $scope.accounting = 'Multiple';
      };

      $scope.statsLoaded = true;
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.get_other_stats = function () {
    workshopAPI.get('/workshop_admin/company_statistics_other', [ $scope.company.id, $scope.stats_period.period ])
    .then(new_stats => {
      $scope.advanced_stats = new_stats;

      $scope.advancedStats = true;
    })
    .catch(err => {
      messages.error(err);
    });


  };

  $scope.updateSingleUsePurchases = function () {
    workshopAPI.post('/workshop_admin/update_single_use_purchases', $scope.singleUsePurchases)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SINGLE_USE_PURCHASES'), 'success');

      $scope.getStats();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.$watch('stats_period.period', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      $scope.get_other_stats();
    }
  });

  $scope.getStats();
}